import {RestServiceAbstract} from "../../base/rest.service.abstract";
import {map, takeUntil} from "rxjs/operators";
import {ResponseModel} from "../../base/response.model";
import {Subject} from "rxjs";
import {Injectable} from "@angular/core";
import {DialogTextModel} from "../models/dialog.text.model";

@Injectable({
  providedIn: 'root',
})
export class DialogRestService extends RestServiceAbstract {
  protected ngUnsubscribe$: Subject<void> = new Subject<void>();

  getDialogs(filter: string) {
    return this.get(`/${this.CMS_URL}/dialogs${filter}`)
    .pipe(takeUntil(this.ngUnsubscribe$),
      map(data => {
        return new ResponseModel<DialogTextModel[]>(data);
      })
    );
  }

  public subscribeToDialogOffer(id: string, idf: string|undefined) {
    return this.post(`/${this.CMS_URL}/dialogs/${id}`, {subscribe: true, idf}).pipe(map(data => {
      return new ResponseModel(data);
    }));
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
